import React, { MouseEvent, useState } from 'react';
import { Typography } from '../Typography/Typography';
import classNames from 'classnames/bind';
import styles from './Avatar.module.scss';
import { avatarBackground } from '../../assets/images';

const cx = classNames.bind(styles);

export interface IAvatarProps {
  variant?: 'primary' | 'secondary';
  initials: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  active?: boolean;
}

const Avatar = ({ active, variant = 'primary', initials, onClick }: IAvatarProps) => {
  const [isHover, setIsHover] = useState<boolean>(false);

  const handleMouseOver = (): void => setIsHover(true);
  const handleMouseOut = (): void => setIsHover(false);

  const hoverCondition = isHover && variant === 'primary';

  return (
    <button
      className={cx(`avatar-${variant}`, {
        active,
        'avatar-primary-on-hover': hoverCondition,
      })}
      data-cy="avatar"
      onClick={onClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      style={{ backgroundImage: `url(${avatarBackground})` }}
    >
      <Typography size="L" weight="semi-bold" className={styles['initials']}>
        {initials}
      </Typography>
    </button>
  );
};

export default Avatar;
